import React from 'react';
import { PropTypes } from 'prop-types';
import {
  Field,
  arrayRemove
} from 'redux-form';
import { connect } from 'react-redux';

export const resolveObjPath = (path, obj) => path
  .split('.')
  .reduce(
    (prev, curr) => (
      prev
        ? prev[curr]
        : undefined
    ),
    obj || window.self
  );

const NestedArrayObjectFieldInput = ({
  input,
  placeholder,
  type,
  className,
  maxLength,
  normalizer
}) => {
  const getNormalizedValue = e => (typeof normalizer === 'function' ? normalizer(e.target.value) : e.target.value);

  return (
    <div>
      <input
        type={ type }
        { ...input }
        placeholder={ placeholder }
        className={ className }
        { ...(maxLength && maxLength > 0 && { maxLength }) }
        onBlur={ (e) => {
          const value = getNormalizedValue(e);
          // eslint-disable-next-line react/prop-types
          input.onBlur(value === '' ? null : value);
        } }
        onChange={ (e) => {
          const value = getNormalizedValue(e);
          // eslint-disable-next-line react/prop-types
          input.onChange(value === '' ? null : value);
        } }
      />
    </div>
  );
};

NestedArrayObjectFieldInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any
  }).isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  normalizer: PropTypes.func
};

NestedArrayObjectFieldInput.defaultProps = {
  placeholder: '',
  type: 'text',
  className: '',
  maxLength: null,
  normalizer: null
};

const NestedArrayObjectFieldComponent = ({
  dispatch,
  name,
  rootField,
  formName,
  maxLength,
  normalizer
}) => (
  <Field
    name={ name }
    component={ NestedArrayObjectFieldInput }
    className="form-input"
    rootField={ rootField }
    { ...(maxLength && maxLength > 0 && { maxLength }) }
    { ...(normalizer && { normalizer }) }
    onBlur={ (event, newVal, prevVal) => {
      if (!prevVal && !newVal) {
        event.preventDefault();
      }
    } }
    normalize={ (value, prevVal, allValues, prevAllValues) => {
      const rootFieldValue = resolveObjPath(rootField, allValues);
      if (rootFieldValue) {
        let isEachChildNull = true;
        const itemIndex = name.replace(/(^.*\[|\].*$)/g, '');
        const rootFieldItem = rootFieldValue[itemIndex];
        Object
          .keys(rootFieldItem)
          .forEach((key) => {
            if (key != null) {
              if (rootFieldItem[key] != null) {
                isEachChildNull = false;
              }
            }
          });
        if (isEachChildNull) {
          dispatch(arrayRemove(formName, rootField, itemIndex));
          return undefined;
        }
      }
      return value;
    } }
  />
);

NestedArrayObjectFieldComponent.defaultProps = {
  maxLength: null,
  normalizer: null
};

NestedArrayObjectFieldComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  rootField: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  normalizer: PropTypes.func
};

const mapDispatchToProps = dispatch => ({ dispatch });

// eslint-disable-next-line import/prefer-default-export
export const NestedArrayObjectField = connect(
  null,
  mapDispatchToProps
)(NestedArrayObjectFieldComponent);
